<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">网点设备</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="
        !showIsEdit &&
          !showIsAdd &&
          !showIsDetail &&
          !showIsChangeAisle &&
          !showIsMachineAddGoods
      "
    >
      <section class="searchBox">
        <span>
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          ><a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
        </span>
        <span class="addStyle" style="margin-right:0" v-show="showIsSearch">
          <a-button @click="showIsAdd = !showIsAdd" type="primary" icon="plus"
            >增加</a-button
          >
        </span>
        <span style="margin-right:0" v-show="showIsSearch">
          <a-button
            @click="showIsChangeAisle = !showIsChangeAisle"
            type="primary"
            >改货道</a-button
          >
        </span>
        <span style="margin-right:20px" v-show="showIsSearch">
          <a-button
            @click="showIsMachineAddGoods = !showIsMachineAddGoods"
            type="danger"
            >进场入库</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:180px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>设备厂商：</label>
          <a-radio-group v-model="firm_id">
            <a-radio :value="1">易触</a-radio>
            <a-radio :value="2">华屹1</a-radio>
            <a-radio :value="3">华屹2</a-radio>
            <a-radio :value="4">卡游</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>设备类型：</label>
          <a-radio-group v-model="version">
            <a-radio :value="1">一代机</a-radio>
            <a-radio :value="2">二代机</a-radio>
            <a-radio :value="3">三代机</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>销售情况：</label>
          <a-radio-group v-model="sale_type">
            <a-radio :value="1">非热销</a-radio>
            <a-radio :value="2">热销</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>是否绑定甲方结算价：</label>
          <a-radio-group v-model="is_setprice">
            <a-radio :value="1">未绑定</a-radio>
            <a-radio :value="2">已绑定</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>是否撤柜退回：</label>
          <a-radio-group v-model="is_return">
            <a-radio :value="1">未撤柜</a-radio>
            <a-radio :value="2">已撤柜</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>撤柜退回渠道：</label>
          <a-radio-group v-model="is_return_type">
            <a-radio :value="1">公司</a-radio>
            <a-radio :value="2">甲方</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>进场入库：</label>
          <a-radio-group v-model="is_entry">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>是否缺货：</label>
          <a-radio-group v-model="is_need_add">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>是否缺物料：</label>
          <a-radio-group v-model="is_need_material">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="网点设备名称|机器码|网点详细地址"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button
            v-show="showIsSearch"
            class="resetStyle"
            @click="downloadMachine"
          >
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.device_name }}</td>
              <!-- <td>{{ item.address }}</td> -->
              <td>
                <p v-show="item.firm_id == 1">易触</p>
                <p v-show="item.firm_id == 2">华屹1</p>
                <p v-show="item.firm_id == 3">华屹2</p>
                <p v-show="item.firm_id == 4">卡游</p>
              </td>
              <!-- <td style="width: 16%">
                <p>{{ item.device_unique_id }}</p>
              </td> -->
              <td>
                <p v-show="item.version == 1">一代机</p>
                <p v-show="item.version == 2">二代机</p>
                <p v-show="item.version == 3">三代机</p>
              </td>
              <td>
                <p v-show="item.sale_type == 1">非热销</p>
                <p v-show="item.sale_type == 2">热销</p>
              </td>
              <td>
                <p v-show="item.is_need_add == 1">是</p>
                <p v-show="item.is_need_add == 2">否</p>
              </td>
              <td>
                {{ item.need_add_time }}
              </td>
              <td>
                <p v-show="item.is_need_material == 1">是</p>
                <p v-show="item.is_need_material == 2">否</p>
              </td>
              <td class="operation">
                <a @click="clientPricePage(item)" style="color:#409EFF"
                  >甲方结算价</a
                >
                <a @click="editPage(item)" style="color:#67C23A">编辑</a>
                <a @click="detailPage(item)" style="color:#777">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 增加 -->
    <addMachine v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 编辑 -->
    <machineEdit
      v-show="showIsEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
    <!-- 详情 -->
    <machineDetail v-show="showIsDetail" :detailVal="detailVal" />
    <!-- 详情 end -->
    <!-- 甲方结算价 -->
    <aside class="dialogsBox" v-show="showIsPriceClient">
      <div>
        <h3>甲方结算价</h3>
        <a class="close" @click="showIsPriceClient = false"
          ><a-icon style="color:#666" type="close-circle"
        /></a>
        <ul>
          <li v-if="priceClientDetail != ''">
            <label>网点设备：</label>
            <p>{{ priceClientDetail.device_name }}</p>
          </li>
          <li v-if="priceClientDetail != ''">
            <label>地址：</label>
            <p>
              {{
                priceClientDetail.province == priceClientDetail.city
                  ? priceClientDetail.province
                  : priceClientDetail.province + priceClientDetail.city
              }}
            </p>
          </li>
          <li>
            <label><i>*</i>补货结算价：</label>
            <a-input-number v-model="price" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label><i>*</i>上新结算价：</label>
            <a-input-number v-model="new_price" />
            <span>&nbsp;元</span>
          </li>
          <li>
            <label><i>*</i>美陈结算价：</label>
            <a-input-number v-model="pretty_price" />
            <span>&nbsp;元</span>
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitPriceClient">
            提交
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 甲方结算价 end -->
    <!-- 改货道 -->
    <changeAisle
      v-show="showIsChangeAisle"
      v-on:hideInChangeAisle="hideInChangeAisle"
    />
    <!-- 改货道 end -->
    <!-- 进场入库 -->
    <machineAddGoods
      v-show="showIsMachineAddGoods"
      v-on:hideInMachineAddGoods="hideInMachineAddGoods"
    />
    <!-- 进场入库 end -->
  </div>
</template>
<script>
import axios from "axios";
import addMachine from "@/components/equipment/addMachine"; //增加
import machineEdit from "@/components/equipment/machineEdit"; //编辑
import machineDetail from "@/components/equipment/machineDetail"; //详情
import changeAisle from "@/components/equipment/changeAisle"; //改货道
import machineAddGoods from "@/components/equipment/machineAddGoods"; //进场入库
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "网点名称",
        // "地址",
        "设备厂商",
        // "设备编号",
        "设备类型",
        "销售情况",
        "是否缺货",
        "缺货时间",
        "是否缺物料",
        "操作"
      ],
      sale_type: "",
      version: "",
      firm_id: "",
      project_id: "",
      query_field: "",
      isHideDetails: false,
      details: {},
      showIsAdd: false,
      proList: [],
      showIsPriceClient: false,
      priceClientDetail: "",
      goodsList: [],
      small_brand_id: "",
      showIsEdit: false,
      editDetail: "",
      showIsDetail: false,
      detailVal: "",
      price: "",
      new_price: "",
      pretty_price: "",
      showIsChangeAisle: false,
      is_setprice: "",
      showIsSearch: false,
      showIsMachineAddGoods: false,
      is_entry: -1,
      is_return_type: 0,
      is_need_material: "",
      is_return: 0,
      is_need_add: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addMachine,
    machineDetail,
    machineEdit,
    changeAisle,
    machineAddGoods
  },
  mounted() {
    this.getData(); //获取列表
    this.getGoods(); //获取单个商品
    this.getPro(); //获取项目
  },
  methods: {
    downloadMachine() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device/listsDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&project_id=" +
        this.project_id +
        "&version=" +
        this.version +
        "&sale_type=" +
        this.sale_type +
        "&firm_id=" +
        this.firm_id +
        "&is_setprice=" +
        this.is_setprice +
        "&is_entry=" +
        this.is_entry +
        "&is_need_material=" +
        this.is_need_material +
        "&is_return_type=" +
        this.is_return_type +
        "&is_return=" +
        this.is_return;
    },
    hideInMachineAddGoods(msg) {
      this.showIsMachineAddGoods = false;
      if (msg) {
        this.reload();
      }
    },
    hideInChangeAisle(msg) {
      this.showIsChangeAisle = false;
      if (msg) {
        this.reload();
      }
    },
    clientPricePage(item) {
      // console.log(item);
      this.priceClientDetail = item;
      this.showIsPriceClient = true;
      this.price = item.price;
      this.new_price = item.new_price;
      this.pretty_price = item.pretty_price;
    },
    editPage(item) {
      this.showIsEdit = true;
      this.editDetail = item;
    },
    hideInEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    submitPriceClient() {
      if (
        this.price !== "" &&
        this.new_price !== "" &&
        this.pretty_price !== ""
      ) {
        if (this.priceClientDetail.is_setprice == 1) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Device_party/add";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_id: this.priceClientDetail.id,
            price: this.price,
            new_price: this.new_price,
            pretty_price: this.pretty_price
          };
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("绑定成功");
              this.showIsPriceClient = false;
              this.reload();
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Device_party/edit";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_id: this.priceClientDetail.id,
            price: this.price,
            id: this.priceClientDetail.device_party_price_id,
            new_price: this.new_price,
            pretty_price: this.pretty_price
          };
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("编辑成功");
              this.showIsPriceClient = false;
              this.reload();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      } else {
        this.$message.error("*为必填项");
      }
    },
    getGoods() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Brand/getBrandList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          count_type: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.goodsList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    goodsRelationDialogs(item) {
      this.showIsPriceClient = true;
      this.priceClientDetail = item;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsEdit = false;
      this.showIsDetail = false;
      this.showIsAdd = false;
      this.showIsChangeAisle = false;
      this.showIsMachineAddGoods = false;
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.firm_id = "";
      this.version = "";
      this.sale_type = "";
      this.is_setprice = "";
      this.is_need_material = "";
      this.is_need_add = "";
      this.is_entry = -1;
      this.is_return_type = 0;
      this.is_return = 0;
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        version: this.version,
        sale_type: this.sale_type,
        firm_id: this.firm_id,
        is_setprice: this.is_setprice,
        is_entry: this.is_entry,
        is_need_material: this.is_need_material,
        is_return_type: this.is_return_type,
        is_return: this.is_return,
        is_need_add: this.is_need_add,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      this.detailVal = item;
      this.showIsDetail = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
